import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=0a8a7183&scoped=true&"
import script from "./FileUpload.vue?vue&type=script&lang=ts&"
export * from "./FileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=0a8a7183&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a7183",
  null
  
)

export default component.exports